import type { ReactNode } from 'react';

export const symbol_elderly_woman: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M527-756q-30 0-51.5-21.5T454-829q0-6 4-22-10-4-16-13t-6-20q0-15 10.5-25.5T472-920q11 0 20 6t13 16q5-2 11-3t11-1q30 0 51.5 21.5T600-829q0 30-21.5 51.5T527-756Zm157.5 346.5Q680-414 680-420v-33q-45-12-90-44t-69-71l-37 118 106 235v175h-60v-160H428L326-64q-8 10-20 12t-22-6q-10-8-12-20t6-22l75-100h-72q-14 0-22-11.5t-7-25.5q6-86 24.5-158T328-542q33-75 71.5-122.5T476-712q28 0 45.5 21t37.5 66q20 46 59 75.5t94 46.5q7-4 13.5-5.5T739-510q23 0 42 18.5t19 41.5v395q0 6-4.5 10.5T785-40q-6 0-10.5-4.5T770-55v-395q0-12-9-21t-21-9q-12 0-21 9t-9 21v30q0 6-4.5 10.5T695-405q-6 0-10.5-4.5Z"
		/>
	</svg>
);
